import logoImage from "@/assets/images/logo.png"
import logoImageDark from "@/assets/images/logo-dark.png"
import { ForgotPasswordForm } from "@/components/auth/forgot-password-form"

/**
 * Forgot password page component
 * Provides email submission form and password reset functionality
 */
export function ForgotPasswordPage() {
  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      {/* Background decoration - same as home page */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 lg:w-96 lg:h-96 bg-primary-100 dark:bg-primary-900/30 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-xl opacity-70" />
        <div className="absolute top-40 right-10 w-72 h-72 lg:w-96 lg:h-96 bg-secondary-100 dark:bg-secondary-900/30 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-xl opacity-70" />
        <div className="absolute -bottom-8 left-20 w-72 h-72 lg:w-96 lg:h-96 bg-primary-50 dark:bg-primary-950/30 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-xl opacity-70" />
      </div>

      {/* Main Content */}
      <div className="relative z-10 min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
        {/* Forgot Password Card - just the card, nothing else */}
        <div className="w-full max-w-md">
          <div className="bg-card shadow-xl rounded-2xl border border-border p-8">
            {/* Logo inside the card */}
            <div className="flex justify-center mb-6">
              <img
                src={logoImage}
                alt="Taqat AI Logo"
                className="h-10 w-auto block dark:hidden"
              />
              <img
                src={logoImageDark}
                alt="Taqat AI Logo"
                className="h-10 w-auto hidden dark:block"
              />
            </div>

            <ForgotPasswordForm />
          </div>
        </div>
      </div>
    </div>
  )
}